export default __webpack_public_path__ + "static/media/driven.3b4b3642.jpg";